import React, { useState, Fragment } from 'react';
import { Button } from '../components/Button';
import { StarIcon, QuoteIcon, ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
import { PhoneIcon, MessageSquareIcon, ClockIcon, CalendarIcon, HelpCircleIcon, BellIcon, CheckIcon, PhoneForwardedIcon, MessageCircleIcon, CalendarCheckIcon, ZapIcon, WorkflowIcon, DatabaseIcon, BrainCircuitIcon } from 'lucide-react';
function ServiceHeroLight() {
  return <section className="w-full bg-white py-20 md:py-32" data-id="element-3420">
      <div className="max-w-7xl mx-auto px-8 md:px-12 text-center" data-id="element-3421">
        <h1 className="font-['Poppins'] font-bold text-5xl md:text-7xl lg:text-8xl text-[#1A1A1A] mb-8 leading-tight" data-id="element-3422">
          Australia's Leading
          <br data-id="element-3423" />
          <span className="text-[#F1B530]" data-id="element-3424">AI Answering Service</span>
        </h1>

        <p className="font-['Inter'] text-xl md:text-2xl text-[#6B6B6B] max-w-4xl mx-auto mb-12 leading-relaxed font-light" data-id="element-3425">
          Professional call answering, 24/7 availability, and seamless
          integration. Trusted by thousands of Australian businesses.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12" data-id="element-3426">
          <Button size="lg" data-id="element-3427">Start Free 7-Day Trial</Button>
          <Button variant="secondary" size="lg" theme="light" data-id="element-3428">
            1300 XXX XXX
          </Button>
        </div>

        <div className="flex items-center justify-center gap-2 text-[#F1B530]" data-id="element-3429">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-current" data-id="element-3430" />)}
          <span className="font-['Inter'] text-[#6B6B6B] ml-2" data-id="element-3431">
            4.9/5 from 500+ reviews
          </span>
        </div>
      </div>
    </section>;
}
function ValuePropositionLight() {
  const benefits = [{
    icon: ClockIcon,
    title: '24/7 Instant Call Answering',
    description: 'Never miss a call again with round-the-clock AI coverage that picks up instantly'
  }, {
    icon: MessageSquareIcon,
    title: 'Customised Company Greeting',
    description: 'Fully branded experience that sounds like your business, not a generic service'
  }, {
    icon: PhoneIcon,
    title: 'Accurate Capture',
    description: 'Precise name, number, and message recording with intelligent transcription'
  }, {
    icon: BellIcon,
    title: 'Real-Time Call Summaries',
    description: 'Instant notifications with complete call context delivered immediately'
  }, {
    icon: HelpCircleIcon,
    title: 'FAQ Handling',
    description: 'Answer common questions with fenced, brand-safe responses automatically'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Booking',
    description: 'Seamless calendar integration for automated scheduling and confirmations'
  }];
  return <section className="w-full bg-[#F5F5F5] py-28 md:py-36" data-id="element-3432">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-3433">
        <div className="text-center mb-20" data-id="element-3434">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl text-[#1A1A1A] mb-6 tracking-tight" data-id="element-3435">
            Why Choose Our AI Answering Service?
          </h2>
          <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B]" data-id="element-3436">
            Your Always-On Receptionist, without the overheads
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3437">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="bg-white rounded-2xl p-10 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md" data-id="element-3438">
                <div className="w-14 h-14 bg-[#F1B530]/10 rounded-xl flex items-center justify-center mb-6 border border-[#F1B530]/20" data-id="element-3439">
                  <Icon className="w-7 h-7 text-[#F1B530]" data-id="element-3440" />
                </div>
                <h3 className="font-['Inter'] font-semibold text-xl text-[#1A1A1A] mb-4" data-id="element-3441">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-3442">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function ProcessStepsLight() {
  const steps = [{
    number: '01',
    title: 'Sign Up',
    description: 'Create your account and customize your AI receptionist in minutes'
  }, {
    number: '02',
    title: 'Configure',
    description: 'Set your greeting, FAQs, and routing rules to match your business'
  }, {
    number: '03',
    title: 'Go Live',
    description: 'Forward your calls and let AI handle everything 24/7'
  }, {
    number: '04',
    title: 'Grow',
    description: 'Monitor performance, capture leads, and scale effortlessly'
  }];
  return <section className="w-full bg-white py-28" data-id="element-3443">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-3444">
        <div className="text-center mb-20" data-id="element-3445">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-3446">
            How It Works
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-3447">
            Get started in 4 simple steps
          </p>
        </div>

        <div className="hidden lg:flex items-stretch gap-4" data-id="element-3448">
          {steps.map((step, index) => <Fragment key={index} data-id="element-3449">
              <div className="flex-1 bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md flex flex-col" data-id="element-3450">
                <div className="font-['Poppins'] text-6xl font-bold text-[#F1B530] mb-6 opacity-50" data-id="element-3451">
                  {step.number}
                </div>
                <h3 className="font-['Inter'] font-bold text-2xl text-[#1A1A1A] mb-4" data-id="element-3452">
                  {step.title}
                </h3>
                <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-3453">
                  {step.description}
                </p>
              </div>

              {index < steps.length - 1 && <div className="flex items-center justify-center px-2" data-id="element-3454">
                  <ArrowRightIcon className="w-6 h-6 text-[#F1B530]" strokeWidth={2} data-id="element-3455" />
                </div>}
            </Fragment>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:hidden" data-id="element-3456">
          {steps.map((step, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md flex flex-col" data-id="element-3457">
              <div className="font-['Poppins'] text-6xl font-bold text-[#F1B530] mb-6 opacity-50" data-id="element-3458">
                {step.number}
              </div>
              <h3 className="font-['Inter'] font-bold text-2xl text-[#1A1A1A] mb-4" data-id="element-3459">
                {step.title}
              </h3>
              <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-3460">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
function IndustryBenefitsLight() {
  const industries = [{
    name: 'Healthcare',
    benefits: ['HIPAA compliant', 'Appointment scheduling', 'Emergency routing', 'Patient messaging']
  }, {
    name: 'Legal',
    benefits: ['Client intake', 'Confidential handling', 'Urgent call screening', 'Case management']
  }, {
    name: 'Real Estate',
    benefits: ['Property inquiries', 'Viewing bookings', 'Lead capture', 'Tenant support']
  }, {
    name: 'Trade Services',
    benefits: ['Job booking', 'Emergency calls', 'Quote requests', 'Service scheduling']
  }, {
    name: 'Retail',
    benefits: ['Order taking', 'Store inquiries', 'Stock checks', 'Customer support']
  }, {
    name: 'Professional Services',
    benefits: ['Client screening', 'Appointment booking', 'Message handling', 'Consultation scheduling']
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-3461">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-3462">
        <div className="text-center mb-16" data-id="element-3463">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-3464">
            Trusted Across Industries
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-3465">
            Tailored solutions for every business type
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3466">
          {industries.map((industry, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-3467">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-6" data-id="element-3468">
                {industry.name}
              </h3>
              <ul className="space-y-3" data-id="element-3469">
                {industry.benefits.map((benefit, idx) => <li key={idx} className="font-['Inter'] text-[#6B6B6B] flex items-start" data-id="element-3470">
                    <span className="text-[#F1B530] mr-2" data-id="element-3471">•</span>
                    {benefit}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}
function PricingPlansLight() {
  const plans = [{
    name: 'Scout 25',
    price: 'AUD $65',
    calls: '25 calls/month',
    minutes: '125',
    target: 'Perfect for solo operators testing the waters',
    inclusions: ['Instant call pickup', 'Customised company greeting', 'Name, number & message capture', 'Real-time call summaries via SMS/email', 'Call recordings & transcripts', 'Dashboard analytics', 'Excess: $2.60/call or $0.52/min'],
    ctaText: 'Start 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Forager 50',
    price: 'AUD $115',
    calls: '50 calls/month',
    minutes: '250',
    target: 'Small teams with steady enquiry flow',
    inclusions: ['Everything in Scout 25', 'Priority support', 'Extended call handling', 'Multi-user dashboard access', 'Custom call routing rules', 'Excess: $2.30/call or $0.46/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording',
    isPopular: true
  }, {
    name: 'Drift 75',
    price: 'AUD $165',
    calls: '75 calls/month',
    minutes: '375',
    target: 'Growing teams with rising call peaks',
    inclusions: ['Everything in Forager 50', 'Advanced analytics', 'Team collaboration tools', 'Custom integrations', 'Dedicated account manager', 'Excess: $2.20/call or $0.44/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Surge 150',
    price: 'AUD $325',
    calls: '150 calls/month',
    minutes: '750',
    target: 'High-tempo operations with regular spikes',
    inclusions: ['Everything in Drift 75', 'Priority call routing', 'Advanced workflow automation', 'Custom reporting', 'API access', 'Excess: $2.17/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Swarm 300',
    price: 'AUD $645',
    calls: '300 calls/month',
    minutes: '1,500',
    target: 'Heavy daily call activity teams',
    inclusions: ['Everything in Surge 150', 'Enterprise-grade security', 'Custom AI training', 'White-label options', 'SLA guarantees', 'Excess: $2.15/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Colony 500',
    price: 'AUD $955',
    calls: '500 calls/month',
    minutes: '2,250',
    target: 'Enterprise-level high-volume operations',
    inclusions: ['Everything in Swarm 300', 'Dedicated infrastructure', 'Custom AI models', 'Advanced compliance features', '24/7 premium support', 'Excess: $1.91/call or $0.42/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'AI Automation Customisation',
    target: 'For businesses requiring advanced automation and integrations beyond standard plans',
    inclusions: ['Custom call volumes', 'Bespoke AI training', 'Enterprise integrations', 'Advanced workflow automation', 'Dedicated success team', 'Custom SLAs'],
    ctaText: 'Contact Sales',
    isCustom: true
  }];
  return <section className="w-full bg-white py-28 md:py-36" data-id="element-3472">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-3473">
        <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] text-center mb-20 tracking-tight" data-id="element-3474">
          Plans
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-3475">
          {plans.slice(0, 6).map((plan, index) => <div key={index} className={`bg-white rounded-2xl p-10 border transition-all duration-300 hover:-translate-y-1 relative flex flex-col h-full shadow-sm hover:shadow-md ${plan.isPopular ? 'border-[#F1B530] ring-2 ring-[#F1B530]/20' : 'border-[#E5E5E5] hover:border-[#F1B530]/50'}`} data-id="element-3476">
              {plan.isPopular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F1B530] text-white px-6 py-2 rounded-full font-['Inter'] font-semibold text-sm" data-id="element-3477">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-3478">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-3479">
                  {plan.name}
                </h3>
                <div className="mb-3" data-id="element-3480">
                  <span className="font-['Poppins'] font-bold text-5xl text-[#1A1A1A]" data-id="element-3481">
                    {plan.price}
                  </span>
                  <span className="text-[#6B6B6B] font-['Inter'] ml-2 text-sm" data-id="element-3482">
                    plus GST/month
                  </span>
                </div>
                <p className="text-[#6B6B6B] font-['Inter'] text-sm mb-2 font-light" data-id="element-3483">
                  Up to {plan.calls} • {plan.minutes} free minutes
                </p>
                <p className="text-[#6B6B6B] font-['Inter'] text-sm italic font-light" data-id="element-3484">
                  {plan.target}
                </p>
              </div>

              <div className="mb-10 flex-grow" data-id="element-3485">
                <ul className="space-y-4" data-id="element-3486">
                  {plan.inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-3487">
                      <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-3488" />
                      <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-3489">
                        {inclusion}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto" data-id="element-3490">
                <Button className="w-full" size="lg" data-id="element-3491">
                  {plan.ctaText}
                </Button>

                {plan.ctaLink && <a href="#" className="block text-center mt-5 text-[#6B6B6B] font-['Inter'] text-sm hover:text-[#F1B530] transition-colors duration-300" data-id="element-3492">
                    {plan.ctaLink}
                  </a>}
              </div>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-3493">
          <div className="bg-white rounded-2xl p-10 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full shadow-sm hover:shadow-md" data-id="element-3494">
            <div className="mb-8" data-id="element-3495">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-3496">
                {plans[6].name}
              </h3>
              <div className="mb-3" data-id="element-3497">
                <span className="font-['Poppins'] font-bold text-4xl text-[#1A1A1A]" data-id="element-3498">
                  Custom Pricing
                </span>
              </div>
              <p className="text-[#6B6B6B] font-['Inter'] text-sm italic font-light" data-id="element-3499">
                {plans[6].target}
              </p>
            </div>

            <div className="mb-10 flex-grow" data-id="element-3500">
              <ul className="space-y-4" data-id="element-3501">
                {plans[6].inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-3502">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-3503" />
                    <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-3504">
                      {inclusion}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-auto" data-id="element-3505">
              <Button className="w-full" size="lg" data-id="element-3506">
                {plans[6].ctaText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialsLight() {
  const testimonials = [{
    quote: "Since switching to this AI answering service, we haven't missed a single lead. The 24/7 coverage is a game-changer for our business.",
    author: 'Sarah Mitchell',
    role: 'Director, Mitchell & Associates Law',
    rating: 5
  }, {
    quote: 'The appointment booking feature alone has saved us 10+ hours per week. Our clients love the instant response time.',
    author: 'James Chen',
    role: 'Practice Manager, Sydney Dental Care',
    rating: 5
  }, {
    quote: 'Professional, reliable, and cost-effective. This service pays for itself in captured opportunities. Highly recommended.',
    author: 'Emma Thompson',
    role: 'Owner, Thompson Real Estate',
    rating: 5
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-3507">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-3508">
        <div className="text-center mb-16" data-id="element-3509">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-3510">
            What Our Clients Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-3511">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 relative shadow-sm hover:shadow-md transition-shadow" data-id="element-3512">
              <QuoteIcon className="w-12 h-12 text-[#F1B530]/20 mb-6" data-id="element-3513" />

              <div className="flex gap-1 mb-6" data-id="element-3514">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F1B530] fill-current" data-id="element-3515" />)}
              </div>

              <p className="font-['Inter'] text-[#1A1A1A] mb-6 leading-relaxed font-light" data-id="element-3516">
                "{testimonial.quote}"
              </p>

              <div data-id="element-3517">
                <div className="font-['Inter'] font-semibold text-[#1A1A1A]" data-id="element-3518">
                  {testimonial.author}
                </div>
                <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-3519">
                  {testimonial.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function AddOnsLight() {
  const addOns = [{
    icon: PhoneForwardedIcon,
    name: 'Live Transfer',
    price: 'AUD $99',
    setup: 'one-time setup',
    features: ['Instant Escalation for Time Sensitive Opportunities', 'Transfers With Full Caller Context', 'Smart Routing Based on Your Real Business Rules']
  }, {
    icon: MessageCircleIcon,
    name: 'FAQ Handling',
    price: 'AUD $299',
    setup: 'one-time fee',
    features: ['Turn AI agent into trained front-line knowledge assistant', 'Fenced responses using only approved information', 'Clear brand-safe responses', 'Faster resolution & reduced message volume']
  }, {
    icon: CalendarCheckIcon,
    name: 'Appointment Booking',
    price: 'AUD $399',
    setup: 'one-time setup',
    features: ['Real-time calendar syncing (Google, Outlook, etc.)', 'Automated booking and confirmation', 'Custom booking rules', 'Caller notifications and internal alerts']
  }];
  return <section className="w-full bg-white py-28 md:py-36" data-id="element-3520">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-3521">
        <div className="text-center mb-20" data-id="element-3522">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6 tracking-tight" data-id="element-3523">
            Universal Add-Ons
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-3xl mx-auto font-light" data-id="element-3524">
            Available for all plans to extend your AI answering service
            capabilities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-3525">
          {addOns.map((addOn, index) => {
          const Icon = addOn.icon;
          return <div key={index} className="bg-white rounded-2xl overflow-hidden border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md" data-id="element-3526">
                <div className="p-10" data-id="element-3527">
                  <div className="w-14 h-14 bg-[#F1B530] rounded-xl flex items-center justify-center mb-6" data-id="element-3528">
                    <Icon className="w-7 h-7 text-white" data-id="element-3529" />
                  </div>

                  <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-3530">
                    {addOn.name}
                  </h3>

                  <div className="mb-8" data-id="element-3531">
                    <span className="font-['Poppins'] font-semibold text-2xl text-[#F1B530]" data-id="element-3532">
                      {addOn.price}
                    </span>
                    <span className="text-[#6B6B6B] font-['Inter'] text-sm ml-2" data-id="element-3533">
                      {addOn.setup}
                    </span>
                  </div>

                  <ul className="space-y-4" data-id="element-3534">
                    {addOn.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-3535">
                        <span className="text-[#F1B530] mr-3 flex-shrink-0 text-lg" data-id="element-3536">
                          •
                        </span>
                        <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-3537">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function AdvancedAutomationLight() {
  const capabilities = [{
    icon: WorkflowIcon,
    text: 'Route leads intelligently'
  }, {
    icon: ZapIcon,
    text: 'Trigger automated workflows'
  }, {
    icon: DatabaseIcon,
    text: 'Sync directly into CRMs'
  }, {
    icon: BrainCircuitIcon,
    text: 'Collect structured information'
  }];
  return <section className="w-full bg-[#F5F5F5] py-28 md:py-36" data-id="element-3538">
      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center" data-id="element-3539">
        <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 text-[#1A1A1A] tracking-tight" data-id="element-3540">
          AI Automation Customisation Advanced
        </h2>
        <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B] mb-10" data-id="element-3541">
          Automate More Than Calls. Automate Your Entire Frontline.
        </p>

        <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-4xl mx-auto mb-16 leading-relaxed font-light" data-id="element-3542">
          For businesses handling 500+ calls per month, unlock advanced
          capabilities that transform your AI answering service into a complete
          frontline automation platform.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-3543">
          {capabilities.map((capability, index) => {
          const Icon = capability.icon;
          return <div key={index} className="bg-white rounded-2xl p-8 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 h-full flex flex-col items-center justify-center min-h-[180px] shadow-sm hover:shadow-md" data-id="element-3544">
                <Icon className="w-10 h-10 text-[#F1B530] mx-auto mb-5" data-id="element-3545" />
                <p className="font-['Inter'] text-[#1A1A1A] font-light text-center" data-id="element-3546">
                  {capability.text}
                </p>
              </div>;
        })}
        </div>

        <Button size="lg" data-id="element-3547">Contact Sales</Button>
      </div>
    </section>;
}
function FAQLight() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the AI answering service work?',
    answer: 'Our AI receptionist answers calls 24/7, captures caller information, handles FAQs, and can even book appointments. It integrates seamlessly with your existing systems and can be customized to match your business needs.'
  }, {
    question: 'Can I customize the greeting and responses?',
    answer: 'Absolutely! You can fully customize your company greeting, upload FAQs, set routing rules, and define your brand voice. The AI learns from your business to provide accurate, on-brand responses.'
  }, {
    question: "What happens if the AI can't handle a call?",
    answer: 'The AI can transfer calls to your team with full context when needed. You set the rules for when calls should be escalated, ensuring important matters always reach the right person.'
  }, {
    question: 'How quickly can I get started?',
    answer: "Setup takes less than 5 minutes. Simply sign up, customize your greeting and settings, forward your number, and you're live. We provide step-by-step guidance throughout the process."
  }, {
    question: 'Is there a contract or commitment?',
    answer: 'No long-term contracts required. Start with our 7-day free trial, then choose a monthly plan that fits your needs. You can upgrade, downgrade, or cancel anytime.'
  }];
  return <section className="w-full bg-white py-28 md:py-36" data-id="element-3548">
      <div className="max-w-4xl mx-auto px-8 md:px-12" data-id="element-3549">
        <div className="text-center mb-16" data-id="element-3550">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-3551">
            Frequently Asked Questions
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] font-light" data-id="element-3552">
            Everything you need to know about our AI answering service
          </p>
        </div>

        <div className="space-y-4" data-id="element-3553">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#F1B530]/50 shadow-sm hover:shadow-md" data-id="element-3554">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left" data-id="element-3555">
                <span className="font-['Inter'] font-semibold text-xl text-[#1A1A1A] pr-8" data-id="element-3556">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F1B530] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-3557" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-3558">
                <div className="px-8 pb-6" data-id="element-3559">
                  <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-3560">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function PhoneServicesInspiredLightBase() {
  return <div className="w-full min-h-screen bg-white" data-id="element-3561">
      <ServiceHeroLight data-id="element-3562" />
      <ValuePropositionLight data-id="element-3563" />
      <ProcessStepsLight data-id="element-3564" />
      <IndustryBenefitsLight data-id="element-3565" />
      <PricingPlansLight data-id="element-3566" />
      <TestimonialsLight data-id="element-3567" />
      <AddOnsLight data-id="element-3568" />
      <AdvancedAutomationLight data-id="element-3569" />
      <FAQLight data-id="element-3570" />
    </div>;
}